<template>
    <div class="full-width-view" v-loading="loading" :style="{width: windowInnerWidth, height: windowInnerHeight}">
        <div class="page-header-box">
            <phoneTitleComponent @goBack="returnFunc" :obj="pageTitleObj" />
        </div>

        <div class="content-box">
            <div class="des-part">
                <div>
                    <span>{{desText}}</span>
                </div>

                <div>
                    <span class="date-text">
                        <font-awesome-icon icon="fa-solid fa-clock" />
                        &nbsp;
                        {{hallObj.addinfo3}} - {{hallObj.addinfo4}}
                    </span>
                </div>
            </div>

            <hallBoothPositionList :list="recordList" :tag="tag" v-if="null != recordList" @submitSelect="selectCallBack" @submitDel="delCallback" />
        </div>

        <el-dialog
                v-model="hallSelectorVisible"
                :title="i18n.tkey('lang_select_goto_hall')"
                :width="isMobile == true?'95%':'50%'"
                align-center
                destroy-on-close
                :close-on-click-modal="false"
                :close-on-press-escape="false"
        >
            <hallSelector @clickGo="clickGetHallData" />
        </el-dialog>
    </div>
</template>

<script setup>
    import phoneTitleComponent from '@/components/phoneTitleComponent.vue'
    import hallBoothPositionList from "@/components/shopopee/hall/hallBoothPositionList"
    import hallSelector from "@/components/shopopee/hall/hallSelector"
    import {inject, ref, onMounted, onBeforeMount, computed, toRef} from "vue";
    import record15Api from "@/request/record15Api";
    import myUtil from "@/util/util";
    import {useUserinfo} from "@/stores/userinfo";
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faClock } from '@fortawesome/free-solid-svg-icons'

    library.add(faClock)

    const props = defineProps(["hid", "tag"])

    const userInfoRef = toRef(useUserinfo())
    const i18n = inject("i18n")

    const windowInnerWidth = ref((window.innerWidth) + "px")
    const windowInnerHeight = ref((window.innerHeight) + "px")

    const pageTitleObj = ref({
        hasBack: true,
        name: null
    })

    const hallSelectorVisible = ref(false)
    const loading = ref(false)
    const recordList = ref(null)
    const hallObj = ref({})

    let currHallId = null

    const isMobile = ('ontouchstart' in document.documentElement)

    const desText = computed(() => {
        let des = ""

        if (userInfoRef.value.lang != "zh" && userInfoRef.value.lang != "szh" && myUtil.isNotEmpty(hallObj.value.addinfo6)){
            des = hallObj.value.addinfo7
        }else{
            des = hallObj.value.addinfo8
        }

        return des
    })

    function getHallName() {
        let name = ""

        if (userInfoRef.value.lang != "zh" && userInfoRef.value.lang != "szh" && myUtil.isNotEmpty(hallObj.value.addinfo6)){
            name = hallObj.value.addinfo6
        }else{
            name = hallObj.value.recordname
        }

        return name
    }

    function getRecordList(){
        loading.value = true

        const request = record15Api.queryAdditionalrecord15PositionStatus
        const params = request.getParams()

        params.updatedid = currHallId

        request.send(params, (res) => {
            loading.value = false
            if (res.code == 200){
                hallObj.value = res.detail
                recordList.value = res.detail.list
                pageTitleObj.value.name = getHallName()
            }else{
                hallObj.value = {}
                recordList.value = []
            }
        })

    }

    function clickGetHallData(obj){
        hallObj.value = obj
        hallSelectorVisible.value = false

        currHallId = obj.id

        getRecordList()
    }

    function selectCallBack(addinfo1, addinfo2){
        if (null != addinfo1 && null != addinfo2){
            loading.value = true

            const request = record15Api.insertNewRecord15
            const params = request.getParams()

            params.addinfo1 = addinfo1
            params.addinfo2 = addinfo2
            params.updatedid = currHallId

            request.send(params, (res) => {
                if (res.code == 200){
                    myUtil.alertSuccess(i18n.tkey("lang_submit_success"))
                    getRecordList()
                }else{
                    myUtil.alertError(res.msg)
                }
            })

        }
    }

    function delCallback(obj) {
        loading.value = true

        const request = record15Api.delAdditionalrecord15
        const params = request.getParams()

        params.id = obj.id

        request.send(params, (res) => {
            if (res.code == 200){
                myUtil.alertSuccess(i18n.tkey("lang_delete_success"))
                recordList.value = null
                getRecordList()
            }else{
                myUtil.alertError(res.msg)
            }
        })

    }

    function returnFunc(){
        hallSelectorVisible.value = true
        recordList.value = null
    }

    onBeforeMount(() => {
        if (null != props.hid){
            currHallId = props.hid
            getRecordList()
        }else{
            loading.value = true
            hallSelectorVisible.value = true
        }
    })

    onMounted(() => {
        console.log(props.tag)
    })

</script>

<style scoped>
    .full-width-view {
        /*width: 100%;*/
        /*height: 100%;*/
        position: relative;
        overflow-y: auto;
        overflow-x: hidden;
    }

    @media screen and (min-width: 520px) {
        .content-box {
            /*width: 100%;*/
            /*height: 100%;*/
            padding: 10px;
            width: 400px;
            height: 600px;
            margin: auto;
            box-sizing: border-box;
            margin-bottom: 20px;
        }
    }

    @media screen and (max-width: 520px) {
        .content-box {
            /*width: 100%;*/
            /*height: 100%;*/
            padding: 10px;
            width: 100%;
            /*height: 600px;*/
            margin: auto;
            box-sizing: border-box;
            margin-bottom: 20px;
        }
    }

    .hall-title {
        color: #303133;
        font-size: 24px;
        font-weight: 600;
    }

    .title-part {
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .page-header-box {
        height: 50px;
        width: 100%;
    }

    .des-part {
        color: #606266;
        font-size: 14px;
        text-align: left;
        margin-bottom: 15px;
        line-height: 2;
    }

    .date-text {
        color: #909399;
    }

</style>